// extracted by mini-css-extract-plugin
module.exports = {"card":"Form_card__2iuTO"};